import createComponent from '../create-component';
export default createComponent([["title",{"key":"svg-title"}],["path",{"fill":"#000","d":"M0 0h512v512H0z","key":"svg-path"}],["g",{"fill":"#fff","key":"svg-g"}]]);